/**
 * @file Shared store actions for the data preparation view.
 */

import { createAction } from "@reduxjs/toolkit";

/** Reset any edits made by the user. */
export const clearUserEdits = createAction<void>("clearUserEdits");
